import { Skeleton } from '@/components/ui/skeleton';

type MoviePosterSkeletonComponent = {
  type: 'carousel' | 'poster';
};

export const MoviePosterSkeletonComponent = ({ type }: MoviePosterSkeletonComponent): React.JSX.Element => {
  if (type === 'carousel') {
    return (
      <div className="flex flex-col gap-sm w-full">
        <Skeleton className="aspect-2/3 max-w-[250px] max-h-[400px] w-full" />
        <Skeleton className="h-4 w-[50%]" />
      </div>
    );
  }

  return (
    <Skeleton className="aspect-[2/3] w-full" />
  );
};
